import ACTION from '../action_constant';
import moment from 'moment';

function postAShipment(state = {} , action){
    switch (action.type) {

      case ACTION.POST_A_SHIPMENT.CLEAR_SHIPMENT_DETAILS:
            return Object.assign({});

      case ACTION.POST_A_SHIPMENT.STORE_POST_A_SHIPMENT_DETAILS:
            return Object.assign({}, state, action.data);
      default:
      return state ;
    }
}

export default postAShipment;



// WEBPACK FOOTER //
// app/post_a_shipment/post_a_shipment_reducer.jsx